import { render, staticRenderFns } from "./ExpirationBadge.vue?vue&type=template&id=2b72b3ba&scoped=true&"
import script from "./ExpirationBadge.vue?vue&type=script&lang=js&"
export * from "./ExpirationBadge.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationBadge.vue?vue&type=style&index=0&id=2b72b3ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b72b3ba",
  null
  
)

export default component.exports